import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';

import { MethodService } from '@/infra/services/method';
import type { CreateMethodRequestDTO, CreateMethodResponseDTO } from '@/core/dto/method';

const Service = MethodService.getInstance();

export const useCreateMethod = () => {
	return useMutation<CreateMethodResponseDTO, unknown, CreateMethodRequestDTO>({
		mutationFn: async (params) => Service.create(params),
		onError: () => {
			message.error(I18n.get('Error creating method'));
		}
	});
};

